<div
  style="
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  "
>
  <!-- placeholder for chart component -->
  <div
    class="chartContainer"
    *ngIf="!resizing && !isLoading && showChartOrGrid"
  >
    <ng-content select="[chart]"></ng-content>
  </div>
  <!-- Grid Component -->
  <div
    class="gridContainer"
    *ngIf="!resizing && !isLoading && !showChartOrGrid"
  >
    <ng-content select="[grid]"></ng-content>
  </div>
  <div
    class="chartContainer"
    *ngIf="resizing || isLoading"
    style="position: relative"
  >
    <!-- loading spinner -->
    <div
      *ngIf="isLoading"
      class="spinner-container-absolute"
      style="background-color: rgba(255, 255, 255, 0.8)"
    >
      <div class="spinner"></div>
    </div>
  </div>
  <div class="settings-panel"
       [style.width.px]="panelWidth"
       [ngClass]="{ collapsed: isCollapsed }"
       style=" height: 100%; display: block; position: relative; margin: 15px; flex-shrink: 0; border-left: 10px solid #D9EDF7; ">
      <div class="collapse-button"
           [title]="collapseTooltip"
           (click)="togglePanel()"
           [ngStyle]="{
        position: 'absolute',
        cursor: 'pointer',
        left: isCollapsed ? '0px' : '.25em'
      }">
          <i class="fa"
             [ngClass]="{
          'fa-chevron-right': !isCollapsed,
          'fa-chevron-left': isCollapsed
        }"></i>
      </div>
      <div class="panel panel-info"
           [ngStyle]="{ display: isCollapsed ? 'none' : 'flex', flexDirection: 'column', height: '100%' }">
          <div class="panel-heading"
               style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-left: 2.5em;
          min-height: 63px;
        ">
              <h5>{{ chartDetails?.title }} Settings</h5>
              <div class="btn-group"
                   style="
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            gap: 10px;
            font-size: 1.5rem;
          "
                   *ngIf="showFormButtons">
                  <button type="button"
                          class="btn-info"
                          (click)="revertSettings()"
                          title="Undo Changes"
                          style="width: 42px; height: 42px">
                      <i class="fa fa-undo" aria-hidden="true"></i>
                  </button>
                  <button type="button"
                          class="btn-info"
                          (click)="saveSettings()"
                          title="save"
                          style="width: 42px; height: 42px">
                      <i class="fa fa-floppy-o" aria-hidden="true"></i>
                  </button>
              </div>
          </div>
          <div class="panel-body" style="flex-grow: 1; overflow-y: auto;">
              <ng-content select="[detailsComponent]"></ng-content>
              <!-- loading spinner -->
              <div *ngIf="isLoading"
                   class="spinner-container-absolute"
                   style="background-color: rgba(255, 255, 255, 0.8)">
                  <div class="spinner"></div>
              </div>
          </div>
      </div>
      <!-- Draggable Resize Handle -->
      <div class="resize-handle"
           (mousedown)="startResizing($event)"
           style="
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-75%, -50%);
    width: 20px;
    height: 40px;
    cursor: ew-resize;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  ">
          <div style="font-size: 18px; color: #999;">⋮</div>
      </div>

  </div>
</div>
